import { TableHeadStyle } from '../../styles/Typography';
import { getNewColumnWidth } from '../../utils/table';
import DefaultInputFilter from '../../components/Table/DefaultInputFilter';
import { useCommonTranslation } from '../i18n/useCommonTranslation';
import { useMemo } from 'react';
import { Column, FilterProps } from 'react-table';
import { ClinicalCommissioningGroup } from '../../types/ccg';

export const useCCGColumns = ({
  lastColumn,
}: {
  lastColumn?: Column<ClinicalCommissioningGroup>;
}) => {
  const { t } = useCommonTranslation();

  return useMemo(() => {
    return [
      {
        Header: t('ccg-name'),
        accessor: 'name',
        cellStyle: TableHeadStyle,
        width: getNewColumnWidth(50),
        Filter: (props: FilterProps<object>) => (
          <DefaultInputFilter
            {...props}
            inputProps={{
              placeholder: t('ccg-name'),
            }}
          />
        ),
      },
      lastColumn,
    ] as Column<ClinicalCommissioningGroup>[];
  }, [t, lastColumn]);
};
